export interface ControlUpsellOffer {
  plan: string;
  webLink: string;
  appLink: string;
  title: string;
  subtitle?: string;
  /** Título exibido só no canal Meu TIM, no lugar de `title` + `subtitle`:
   * cada item é uma linha do título. */
  meuTimTitle?: string[];
}

// Chave = id do produto de recarga em centavos (mesmo padrão de RechargeValue.id)
// `webLink` = URL de Web (lojavirtualtim.com.br). `appLink` = deeplink de App.
// A partir da TPC-3639 o appLink não carrega mais os placeholders
// {timid}/{appinstanceid}/{appsflyerid}/{getsessionid} — a TIM não precisa
// mais desses dados nesse link.
export const CONTROL_UPSELL_OFFERS: Record<number, ControlUpsellOffer> = {
  3000: {
    plan: 'TIM Controle Fit Mensal 1.0',
    webLink:
      'https://lojavirtualtim.com.br/PRM007219X/flash-sales?utm_source=captive_upsell_recarga&utm_medium=upsell_recarga&utm_campaign=upsell_recarga_CTRL_FIT_3500&jornada=portabilidade_aquisicao',
    appLink:
      '/misc/e-comm/?pop=true&path=PRM007219X/transicao-jornada-oneclick?utm_source=appmeutim_upsell_recarga&utm_medium=upsell_recarga&utm_campaign=upsell_recarga_CTRL_FIT_3500&jornada=portabilidade_aquisicao',
    title:
      'Por mais R$ 5 contrate o plano TIM Controle Fit Mensal 1.0 com 33GB',
    subtitle: 'Oferta por tempo limitado',
    meuTimTitle: [
      'ATENÇÃO!',
      'Oferta por tempo limitado.',
      'Por mais R$5,00 Contrate o TIM Controle com 33GB',
    ],
  },
  4000: {
    plan: 'TIM Start Express',
    webLink:
      'https://lojavirtualtim.com.br/PRM001499X/flash-sales?utm_source=captive_upsell_recarga&utm_medium=upsell_recarga&utm_campaign=upsell_recarga_CTRL_START_4999&jornada=portabilidade_aquisicao',
    appLink:
      '/misc/e-comm/?pop=true&path=PRM001499X/transicao-jornada-oneclick?utm_source=appmeutim_upsell_recarga&utm_medium=upsell_recarga&utm_campaign=upsell_recarga_CTRL_START_4999&jornada=portabilidade_aquisicao',
    title: 'Por mais R$ 9,99 contrate o plano TIM Start Express com 45GB',
    subtitle: 'Oferta por tempo limitado',
    meuTimTitle: [
      'ATENÇÃO!',
      'Oferta por tempo limitado.',
      'Por mais R$9,99 Contrate o TIM Controle com 45GB',
    ],
  },
};
